import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: white;
  padding: 15px;
  display: flex;
  gap: 15px;
  flex-direction: column;
`;

export const FormWrapper = styled.div`
  /* padding: 15px; */
  /* margin-top: 15px; */
`;

export const ImgWrapper = styled.div`
  position: relative;
  border-bottom: 1px solid black;
  img {
    width: 100%;
    height: 100%;
  }
`;

export const UploadImgWrapper = styled.label`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -25px;
  right: 15px;
  border: 1px solid black;
  background-color: white;
  font-size: 20px;
  border-radius: 50%;
  input {
    display: none;
  }
`;

export const GoBackBtn = styled.div`
  /* position: absolute;
  top: 10px;
  left: 10px; */
  /* background-color: black; */
  /* z-index: 10; */
  width: 40px;
  height: 40px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid black;
`;
